import styles from './HomePage.module.css'
export default function HomePage() {
  return (
    <>
      <div className={styles.HomePageContainer}>
        <div className={styles.HomePageContainer1}>
          <div className={styles.HomePageContent}>
            <div className={styles.HomePageTitle}>
              Proqram təkmilləşdirilməsini bizə əmanət edə bilərsiniz
            </div>
            <div className={styles.HomePageText}>
              Inbit MMC Bitrix24 CRM'in rəsmi Distributorudur. <br/>
              Kommunikasiya infrastrukturu, 1C Proqtam təminatının təkmilləşdirilməsini bizə əmanət edə bilərsiniz.
            </div>
            <div className={styles.HomePageButton}>Daha çox</div>
          </div>
          <img className={styles.HomePageImg} alt='Home Page Image' src='https://images.unsplash.com/photo-1600493033157-eed3fbe95d96?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80'/>
        </div>
      </div>
    </>
  )
}